import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Tooltip,
} from "@mui/material";
import { ContentCopy as ContentCopyIcon } from "@mui/icons-material";
import "./ReportModal.css"; // Custom CSS for your styling

const ReportModal = ({ open, onClose, report }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  if (!report) {
    // If there's no report yet, just return null or a skeleton
    return null;
  }

  const handleCopyReport = async () => {
    if (!report) return;

    const reportText = `
SESSION REPORT
==============

Generated Date: ${new Date().toLocaleDateString()}

STRENGTH POINTS
---------------
${report.strength_points || "N/A"}

POINTS TO IMPROVE
-----------------
${report.points_to_improve || "N/A"}

RECOMMENDATION
--------------
${report.recommendation || "N/A"}
    `.trim();

    try {
      await navigator.clipboard.writeText(reportText);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000); // Reset after 2 seconds
    } catch (err) {
      console.error("Failed to copy report to clipboard:", err);
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = reportText;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="report-modal-title">
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Session Report</Typography>
          <Tooltip
            title={copySuccess ? "Copied!" : "Copy Report to Clipboard"}
            arrow
          >
            <Button
              variant="outlined"
              size="small"
              startIcon={<ContentCopyIcon />}
              onClick={handleCopyReport}
              color={copySuccess ? "success" : "primary"}
              sx={{
                minWidth: "auto",
                px: 2,
                ...(copySuccess && {
                  backgroundColor: "success.light",
                  color: "success.contrastText",
                  "&:hover": {
                    backgroundColor: "success.main",
                  },
                }),
              }}
            >
              {copySuccess ? "Copied!" : "Copy"}
            </Button>
          </Tooltip>
        </Box>
      </DialogTitle>
      <DialogContent className="report-modal-content">
        {/* Strength Points */}
        <Box className="report-section">
          <Typography variant="subtitle1" className="report-label">
            Strength Points:
          </Typography>
          <Typography variant="body1" className="report-text">
            {report.strength_points || "N/A"}
          </Typography>
        </Box>

        {/* Points to Improve */}
        <Box className="report-section">
          <Typography variant="subtitle1" className="report-label">
            Points to Improve:
          </Typography>
          <Typography variant="body1" className="report-text">
            {report.points_to_improve || "N/A"}
          </Typography>
        </Box>

        {/* Recommendation */}
        <Box className="report-section">
          <Typography variant="subtitle1" className="report-label">
            Recommendation:
          </Typography>
          <Typography variant="body1" className="report-text">
            {report.recommendation || "N/A"}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} className="report-modal-close-button">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportModal;
